import { allImagesNew as nintendoImages } from '../../images/nintendoShopItem';
import { allImagesNew as steamImages } from '../../images/steamShopItem';
import { allImagesNew as psnImages } from '../../images/psnShopItem';

const shopImagesMap = {
   steam: steamImages,
   psn: psnImages,
   eshop: nintendoImages,
};

export const shopItemImageSelector = (shop, region, denomination) => {
   const images = shopImagesMap[shop];
   if (!images) return undefined;
   return (
      images.find((item) => item.includes(`${shop}-${region?.toLowerCase()}-${denomination}.`)) ||
      images.find((item) => item.includes(`${shop}-default.`))
   );
};
